import { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from 'react-redux';
import { RootState } from '../redux/store';
import { RouteComponentProps, withRouter } from 'react-router';
import Select from 'react-select';
import { useForm } from 'react-hook-form';
import 'antd/dist/antd.css';
import { addedUser, startAddingUser, startUpdatingUser, updatedUser } from '../redux/actions';
import { addUser, updateUser } from '../utils/api';
import Alert from 'react-bootstrap/Alert';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { Form } from 'react-bootstrap';


interface Props {
  error: boolean;
  message: string;
  loading: boolean;
}
interface DispatchProps {
  startAddingUser: () => void;
  addedUser: (
    username: string,
    groups: string[],
    message: string,
    error: boolean,
  ) => {
    type: string;
    payload: {
      username: string;
      groups: string[];
      message: string;
      error: boolean;
    };
  };
  startUpdatingUser: () => void;
  updatedUser: (
    username: string,
    groups: string[],
    message: string,
    error: boolean,
  ) => {
    type: string;
    payload: {
      username: string;
      groups: string[],
      message: string;
      error: boolean;
    };
  };
}

type ComposedProps = Props & DispatchProps & RouteComponentProps<{ id: string }>;

const UserForm = (props: ComposedProps): JSX.Element => {
  const selectRef = useRef<any>([]);
  const { users } = useAppSelector((state) => state.users);
  const { groups } = useAppSelector((state) => state.groups);
  const userToEdit =
    props.match.params.id !== 'add' && users ? users.filter((item: any) => item.username === props.match.params.id) : null;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      username: userToEdit ? userToEdit[0]?.username : null,
    },
  });

  const id = props.match.params.id;

  const [submitting, setSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState(false);
  const [isDisabledId, setisDisabledId] = useState<boolean>(false);

  const grps = () => {
    let array: any[] = [];
    let g = userToEdit[0]?.groups;
    (g || []).map(item=>{
      array.push({label:item, value:item});
    })
    return array;
  }

  const groupsSelect = () => {
    let groupsList : any[] = [];
    (groups || []).map((group: { groupId: any; })=>{
      if(group.groupId !== 'ALL_PERMISSIONS_GROUP'){
        groupsList.push({label:group.groupId,value:group.groupId})
      }
    })
    return groupsList;
  }

  const [groupsValues, setGroupsValues] = useState<string[]>(userToEdit && userToEdit[0] && userToEdit[0]?.groups ? grps() : groupsSelect()[0]);

  const onSubmit = async (data) => {
    setSubmitting(true);
    setShowAlert(false);
    props.startAddingUser();
    let array: any[] = [];
    array.push(groupsValues)
    let gv: any[] = [];
    if(groupsValues.length===undefined){
      gv.push(array[0].value);
    }else{
      gv = groupsValues
    }
    if(gv?.length > 0){
      addUser(data.username, gv)
        .then((response) => {
          props.addedUser(data.username, gv, 'Started user add', false);
          setValue('username', null);
          if (selectRef !== null && selectRef.current !== null) {
            //selectRef.current.clearValue()
            setGroupsValues(groupsSelect()[0])
          }
          setShowAlert(true);
          setSubmitting(false);
          setError(false);
        })
        .catch((error) => {
          props.addedUser(data.username, gv, 'Failed to add user', true);
          setShowAlert(true);
          setSubmitting(false);
          setError(true);
        });
    }
  };

  /**
   * send a put request to update edited data
   * @param data the data passed through form fields
   */
  const onUpdate = async (data) => {
    
    setSubmitting(true);
    setShowAlert(false);

    let stop = false;
    let array: any[] = [];
    let gv: any[] = [];
    (groupsValues || []).map(item=>{
      array.push(item);
    });
    !stop && (array || []).map(item=>{
      if(item.value!==undefined){
        gv.push(item.value);
      }else{
        gv = groupsValues
        stop = true;
      }
    })
    if(gv?.length > 0){
      updateUser(data.username, gv)
        .then((response) => {
          props.updatedUser(
            data.grouId,
            gv,
            'Started user update',
            false,
          );
          setShowAlert(true);
          setSubmitting(false);
          setError(false);
        })
        .catch((error) => {
          props.updatedUser(
            data.grouId,
            gv,
            'Failed to update user',
            true,
          );
          setShowAlert(true);
          setSubmitting(false);
          setError(true);
        });
    }
  };

  /**
   * handle action on submitting. If user try to add new podcast calls [onSubmit] else [onUpdate] functions
   * @param data the data passed through form fields
   */
  const onSubmitActionHandler = async (data) => {
    if (id === 'add') {
      await onSubmit(data);
    } else {
      await onUpdate(data);
      setShowAlert(true);
    }
  };

  const onSelectChange = (e) => {
    let array : string[] = [];
    (e || []).map(g=>{
      array.push(g.value)   
    })
    setGroupsValues(array)
  }

  const alertVariant = error ? 'danger' : 'success';

  const alertMessage = error ? 'Failed to add user.' : 'User added.';
  const alertUpdateMessage = error ? 'Failed to update user.' : 'User updated.';

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (id !== 'add') {
      setisDisabledId(true);
    }
  }, []);

  return (
    <div>
      {showAlert && (
        <Alert variant={alertVariant} dismissible onClose={() => setShowAlert(false)}>
          {id === 'add' ? alertMessage : alertUpdateMessage}
        </Alert>
      )}
      <div className="w-full border mx-auto p-4">
        <form onSubmit={handleSubmit(onSubmitActionHandler)}>
          <div className="mb-4">
            <h2 className="text-4xl font-medium leading-tight mt-0 text-black-600">
              {id === 'add' ? 'Add a user' : `Edit ${id} user`}
            </h2>
          </div>
          <div className="flex items-center mb-6">
            <div className="width-fix">
              <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">Username:</label>
            </div>
            <div>
              <input
                disabled={submitting || isDisabledId}
                className="appearance-none border border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                type="text"
                {...register('username', { required: true, pattern: /^[a-zA-Z0-9]+$/gi })}
              />
              {errors.username?.type === 'required' && <div className="text-red-500 text-left">This field is required</div>}
              {errors.username?.type === "pattern" && <div className="text-red-500 text-left">Enter only alphanumeric characters</div> }
            </div>
          </div>
          <div className="flex items-center mb-6">
            <div className="width-fix">
              <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">Groups:</label>
            </div>
            <div style={{width:'250px'}}>
              <Select
                ref={selectRef}
                isMulti
                onChange={onSelectChange}
                options={groupsSelect()}
                placeholder=''
                closeMenuOnSelect={false}
                defaultValue={groupsValues}
              />
              {groupsValues?.length === 0 && <div className="text-red-500 text-left">This field is required</div>}
            </div>
          </div>

          <div className="flex items-center">
            <div className="">
              <button
                disabled={submitting}
                type="submit"
                className="add-button shadow bg-green-500 hover:bg-green-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4"
              >
                {id === 'add' ? 'Add User' : 'Update User'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    error: state.users.error,
    message: state.users.message,
    loading: state.users.loading,
  };
};

const dispatchToProps: DispatchProps = {
  startAddingUser,
  addedUser,
  startUpdatingUser,
  updatedUser,
};

export default connect(mapStateToProps, dispatchToProps)(withRouter(UserForm));
